import {
    faAngleRight,
    faBarcode,
    faCheck,
    faCopy,
    faDollarSign,
    faDoorOpen,
    // faEnvelope,
    faHome,
    faInfo,
    faLink,
    faSearchDollar,
    faTimes,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import {
    ListarProdutosPorContaCompleto,
    VerificaProdutoAdimplenteController,
} from "../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import moment from "moment";
import "moment/locale/pt-br";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ModalComponent from "../../../Modais";
import { AbrirAtendimentoSelecionandoTipoCaso } from "../../Atendimento/AbrirAtendimento";
import { IClienteCompleto } from "../../../../Interfaces/Geral/Cliente/IClienteSimples";
import { ACESSOS } from "../../../../Routes/Acessos";
import ExtradoDoCliente from "../../../../Pages/Cobranca/Atendimento/ExtratoDoCliente";
import GerarBoletoModal from "../../GerarBoletoModal";
import { useClientePage } from "../../../../Context/ClientePage";
import ParcelasAbertasCard from "../../ParcelasAbertas";
import DadosFinanceiros from "../../DadosFinanceiros";
import InformacoesVenda from "../../ProdutosCobranca/InformacoesVenda";
import { useUserInfor } from "../../../../Context/User";
// import ModalEnviarFormulario from "../../../../Pages/Geral/GestaoClientes/ModalEnviarFormulario";
import VincularJornadaEtapa from "../../../Menu/GeralTab/subnavs/GestaoCadastro/JornadaEtapa/VincularEtapaJornada";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { FormatterCPF } from "../../../../Validations/InputMasks";
//import { useNotificacaoAlerta } from "../../../../Context/NotificacaoAlerta";
import { IComponentModal } from "../../../Modais/IModalComponent";
import { useModuloInfo } from "../../../../Context/ModuloInfo";

interface IProdutoCards {
    idConta: number;
    cliente?: IClienteCompleto;
    DefaultDescAberturaDeCaso?: string;
}

const tipoCaso = {
    Atendimento: {
        url_base: ACESSOS.ATENDIMENTO.DS_BASE_URL,
        idTipoCaso: ACESSOS.ATENDIMENTO.ID_MODULO,
        icon: faUsers,
        name: "ao Cliente",
    },
    Cobranca: {
        idTipoCaso: ACESSOS.COBRANCA.ID_MODULO,
        url_base: ACESSOS.COBRANCA.DS_BASE_URL,
        icon: faSearchDollar,
        name: "de Cobrança",
    },
};

export default function ProdutosCards(props: IProdutoCards) {
    moment.locale("pt-br");
    // const [lstProdutos, setLstProdutos] = useState<Array<IContaProduto>>([]);
    const { OrgInfor } = useUserInfor();

    const modulo = useClientePage()?.modulo || "Geral";

    const { id } = useModuloInfo();

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [statuses, setStatuses] = useState<(boolean | null)[]>([]);
    const [verificandoAdimplencia, setVerificandoAdimplencia] = useState(true);

    const boletosTitle =
        OrgInfor.COD_ERP_INTEGRACAO === "SIENGE" ? "Boletos" : "Gerar Boleto";

    const {
        value: lstProdutos,
        // loading: lstProdutosLoading,
        execute: updateList,
    } = useAsyncEffect(
        () =>
            ListarProdutosPorContaCompleto(
                props.idConta,
                modulo === "Geral" ? 0 : tipoCaso[modulo].idTipoCaso
            ),
        [props.idConta, modulo]
    );

    lstProdutos?.sort((a, b) =>
        b.UNIDADE.FL_STATUS_VENDA === a.UNIDADE.FL_STATUS_VENDA
            ? 0
            : b.UNIDADE.FL_STATUS_VENDA
            ? 1
            : -1
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const statusesArray = await Promise.all(
                    lstProdutos?.map(async (produto) => {
                        try {
                            if (produto.UNIDADE.ID_CHAVE_ERP_VENDA) {
                                const res =
                                    await VerificaProdutoAdimplenteController(
                                        produto.UNIDADE.ID_CHAVE_ERP_VENDA
                                    );
                                return res;
                            } else {
                                return null;
                            }
                        } catch (error) {
                            return null;
                        }
                    }) || []
                );

                setStatuses(statusesArray);
            } finally {
                setVerificandoAdimplencia(false);
            }
        };

        fetchData();
    }, [lstProdutos]);

    return lstProdutos?.length ? (
        <>
            <div className="row">
                {lstProdutos?.map((res, index) => {
                    const [empresa, obra, venda] =
                        res.UNIDADE.ID_CHAVE_ERP_VENDA?.split("_") || [];

                    const adimplenciaValue = statuses[index];

                    const semChaveErp =
                        res.UNIDADE.ID_CHAVE_ERP_VENDA === null ||
                        res.UNIDADE.ID_CHAVE_ERP_VENDA === "";

                    const getStatusClass = () => {
                        if (semChaveErp) {
                            return "symbol-light-dark";
                        } else if (
                            verificandoAdimplencia ||
                            adimplenciaValue === null
                        ) {
                            return "symbol-light-warning";
                        } else {
                            return adimplenciaValue
                                ? "symbol-light-danger"
                                : "symbol-light-success";
                        }
                    };

                    return (
                        <div
                            key={res.UNIDADE.ID_CHAVE_ERP_VENDA}
                            className="col-md-4"
                        >
                            <div className="card card-custom gutter-b card-stretch">
                                <div className="card-header ribbon ribbon-top ribbon-ver">
                                    {res.UNIDADE.FL_STATUS_VENDA ? (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="tooltip-disabled">
                                                    Venda Ativa
                                                </Tooltip>
                                            }
                                        >
                                            <div
                                                className="ribbon-target bg-success"
                                                style={{
                                                    top: "-2px",
                                                    right: "20px",
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faCheck}
                                                />
                                            </div>
                                        </OverlayTrigger>
                                    ) : (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="tooltip-disabled">
                                                    Venda Desativada
                                                </Tooltip>
                                            }
                                        >
                                            <div
                                                className="ribbon-target bg-danger"
                                                style={{
                                                    top: "-2px",
                                                    right: "20px",
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faTimes}
                                                />
                                            </div>
                                        </OverlayTrigger>
                                    )}
                                    <h3 className="card-title">
                                        <div className="d-flex align-items-end justify-content-end g-2 mr-5">
                                            <div className="flex-shrink-0 mt-lg-0 mt-3">
                                                <OverlayTrigger
                                                    overlay={
                                                        <Tooltip id="tooltip-disabled">
                                                            {semChaveErp
                                                                ? "Sem chave ERP cadastrada"
                                                                : verificandoAdimplencia ||
                                                                  adimplenciaValue ===
                                                                      null
                                                                ? "Carregando..."
                                                                : adimplenciaValue
                                                                ? "Venda Inadimplente"
                                                                : "Venda Adimplente"}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div
                                                        className={`symbol symbol-md-50 ${getStatusClass()}`}
                                                    >
                                                        <span className="symbol-label font-size-h3 font-weight-boldest">
                                                            <FontAwesomeIcon
                                                                icon={faHome}
                                                            />
                                                        </span>
                                                    </div>
                                                </OverlayTrigger>
                                            </div>
                                            <div className="d-flex flex-column">
                                                <span className="text-dark font-weight-bold text-hover-primary font-size-h5 mb-0">
                                                    {res.UNIDADE.DS_UNIDADE}
                                                </span>
                                                <span className="text-muted font-weight-bold">
                                                    {res.DS_EMPREENDIMENTO}
                                                </span>
                                            </div>
                                        </div>
                                    </h3>
                                </div>
                                <div className="card-body pt-4 d-flex flex-column justify-content-between ribbon ribbon-top ribbon-ver">
                                    <div className="mb-7">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                Valor
                                            </span>
                                            <span className="text-muted font-weight-bold">
                                                {formatMoneyReais(
                                                    res.UNIDADE.VL_PRODUTO || 0
                                                )}
                                            </span>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                Data da Venda
                                            </span>
                                            <span className="text-muted font-weight-bold">
                                                {moment(
                                                    res.UNIDADE.DT_VENDA
                                                ).format("LL")}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-cente my-1">
                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                ID CHAVE ERP
                                            </span>
                                            <span className="text-muted font-weight-bold">
                                                {res.UNIDADE.ID_CHAVE_ERP_VENDA}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-cente my-1">
                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                Etapa da Jornada
                                            </span>
                                            <span className="text-muted font-weight-bold">
                                                {res?.DS_ETAPA_JORNADA}
                                            </span>
                                        </div>
                                        {res.NR_SPE_CNPJ && (
                                            <div className="d-flex justify-content-between align-items-cente my-1">
                                                <span className="text-dark-75 font-weight-bolder mr-2">
                                                    CNPJ da coligada
                                                </span>
                                                <span className="text-muted font-weight-bold">
                                                    {FormatterCPF(
                                                        String(res.NR_SPE_CNPJ)
                                                    )}
                                                </span>
                                            </div>
                                        )}
                                        {res.UNIDADE.ID_CHAVE_SIENGE && (
                                            <div className="d-flex justify-content-between align-items-cente my-1">
                                                <span className="text-dark-75 font-weight-bolder mr-2">
                                                    ID TÍTULO SIENGE
                                                </span>
                                                <span className="text-muted font-weight-bold">
                                                    {
                                                        res.UNIDADE
                                                            .ID_CHAVE_SIENGE
                                                    }
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center flex-wrap">
                                        {res.UNIDADE.ID_CHAVE_ERP_VENDA && (
                                            <button
                                                className="flex-grow-1 btn btn-sm  btn-light-warning btn-shadow font-weight-bold text-uppercase py-4 m-1"
                                                onClick={() => {
                                                    if (
                                                        res.UNIDADE
                                                            .ID_CHAVE_ERP_VENDA
                                                    ) {
                                                        setModal({
                                                            Component: () => (
                                                                <DadosFinanceiros
                                                                    ID_CHAVE_ERP={
                                                                        res
                                                                            .UNIDADE
                                                                            .ID_CHAVE_ERP_VENDA ??
                                                                        ""
                                                                    }
                                                                />
                                                            ),
                                                            IconHeader:
                                                                faSearchDollar,
                                                            headerComponent:
                                                                "Dados Financeiros",
                                                            size: "lg",
                                                        });
                                                        setShow(true);
                                                    }
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faSearchDollar}
                                                    className="mr-2 icon-md"
                                                />{" "}
                                                Dados Financeiros
                                            </button>
                                        )}
                                        {res.UNIDADE.ID_CHAVE_ERP_VENDA &&
                                            OrgInfor.COD_ERP_INTEGRACAO ===
                                                "UAU" && (
                                                <button
                                                    className="flex-grow-1 btn btn-sm  btn-light-primary btn-shadow font-weight-bold text-uppercase py-4 m-1"
                                                    onClick={() => {
                                                        if (
                                                            res.UNIDADE
                                                                .ID_CHAVE_ERP_VENDA
                                                        ) {
                                                            setModal({
                                                                Component:
                                                                    () => (
                                                                        <InformacoesVenda
                                                                            ID_CHAVE_ERP_VENDA={
                                                                                res
                                                                                    .UNIDADE
                                                                                    .ID_CHAVE_ERP_VENDA ??
                                                                                ""
                                                                            }
                                                                            DS_EMPREENDIMENTO={
                                                                                res.DS_EMPREENDIMENTO
                                                                            }
                                                                            DS_UNIDADE={
                                                                                res
                                                                                    .UNIDADE
                                                                                    .DS_UNIDADE
                                                                            }
                                                                        />
                                                                    ),
                                                                IconHeader:
                                                                    faInfo,
                                                                headerComponent:
                                                                    "Informações da Venda",
                                                                size: "lg",
                                                            });
                                                            setShow(true);
                                                        }
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faInfo}
                                                        className="mr-2 icon-md"
                                                    />{" "}
                                                    Informações da Venda
                                                </button>
                                            )}
                                        {res.UNIDADE.FL_STATUS_VENDA && (
                                            <>
                                                {modulo === "Atendimento" && (
                                                    <>
                                                        <button
                                                            className="flex-grow-1 btn btn-sm btn-light-warning font-weight-bolder btn-shadow text-uppercase py-4 m-1"
                                                            onClick={() => {
                                                                setModal({
                                                                    headerComponent:
                                                                        "Extrato do Cliente",
                                                                    IconHeader:
                                                                        faAngleRight,
                                                                    Component:
                                                                        () => (
                                                                            <ExtradoDoCliente
                                                                                setShow={
                                                                                    setShow
                                                                                }
                                                                                Atendimento={{
                                                                                    DS_OBRA:
                                                                                        obra,
                                                                                    ID_CONTA:
                                                                                        props.idConta,
                                                                                    ID_PRODUTO:
                                                                                        res.ID_EMPREENDIMENTO,
                                                                                    NR_VENDA:
                                                                                        Number.parseInt(
                                                                                            venda
                                                                                        ),
                                                                                    ID_EMPRESA:
                                                                                        Number.parseInt(
                                                                                            empresa
                                                                                        ),
                                                                                    idTipoCaso:
                                                                                        ACESSOS
                                                                                            .ATENDIMENTO
                                                                                            .ID_MODULO,
                                                                                }}
                                                                                Produto={
                                                                                    res
                                                                                }
                                                                            />
                                                                        ),
                                                                    size: "lg",
                                                                });
                                                                setShow(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faCopy}
                                                                className="mr-2 icon-md"
                                                            />
                                                            Gerar Extrato
                                                        </button>
                                                        <button
                                                            className="flex-grow-1 btn btn-sm  btn-light-primary btn-shadow font-weight-bold text-uppercase py-4 m-1"
                                                            onClick={() => {
                                                                setModal({
                                                                    Component:
                                                                        () => (
                                                                            <GerarBoletoModal
                                                                                empreendimento={
                                                                                    res.DS_EMPREENDIMENTO
                                                                                }
                                                                                unidade={
                                                                                    res
                                                                                        .UNIDADE
                                                                                        .DS_UNIDADE
                                                                                }
                                                                                ID_CONTA={
                                                                                    props.idConta
                                                                                }
                                                                                idTipoCaso={
                                                                                    ACESSOS
                                                                                        .ATENDIMENTO
                                                                                        .ID_MODULO
                                                                                }
                                                                                parcelasRequest={{
                                                                                    DS_OBRA:
                                                                                        obra,
                                                                                    NR_VENDA:
                                                                                        Number.parseInt(
                                                                                            venda
                                                                                        ),
                                                                                    NR_EMPRESA:
                                                                                        Number.parseInt(
                                                                                            empresa
                                                                                        ),
                                                                                }}
                                                                            />
                                                                        ),
                                                                    headerComponent:
                                                                        boletosTitle,
                                                                    IconHeader:
                                                                        faBarcode,
                                                                    size: "xl",
                                                                    noFooter:
                                                                        true,
                                                                    noBody: true,
                                                                    scrollable:
                                                                        true,
                                                                });
                                                                setShow(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faBarcode}
                                                                className="mr-2 icon-md"
                                                            />{" "}
                                                            {boletosTitle}
                                                        </button>
                                                    </>
                                                )}

                                                {adimplenciaValue && (
                                                    <button
                                                        className="flex-grow-1 btn btn-sm  btn-light-danger btn-shadow font-weight-bold text-uppercase py-4 m-1"
                                                        onClick={() => {
                                                            setModal({
                                                                Component:
                                                                    () => (
                                                                        <ParcelasAbertasCard
                                                                            ID_CHAVE_ERP={
                                                                                res
                                                                                    .UNIDADE
                                                                                    .ID_CHAVE_ERP_VENDA
                                                                            }
                                                                            mostrarIndicadores={{
                                                                                DS_PRODUTO:
                                                                                    res.DS_EMPREENDIMENTO,
                                                                                DS_UNIDADE:
                                                                                    res
                                                                                        .UNIDADE
                                                                                        .DS_UNIDADE,
                                                                            }}
                                                                        />
                                                                    ),
                                                                IconHeader:
                                                                    faDollarSign,
                                                                headerComponent:
                                                                    "Parcelas em Aberto",
                                                                size: "lg",
                                                            });
                                                            setShow(true);
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faDollarSign}
                                                            className="mr-2 icon-md"
                                                        />{" "}
                                                        Parcelas em aberto
                                                    </button>
                                                )}
                                            </>
                                        )}

                                        {/* <button
                                            type="button"
                                            className="flex-grow-1 btn btn-sm  btn-light-success btn-shadow font-weight-bold text-uppercase py-4 m-1"
                                            onClick={() => {
                                                setShow(true);
                                                setModal({
                                                    headerComponent:
                                                        "Enviar Formulário",
                                                    IconHeader: faAngleRight,
                                                    Component: () => (
                                                        <ModalEnviarFormulario
                                                            idConta={
                                                                props.idConta
                                                            }
                                                            idProduto={
                                                                res.UNIDADE
                                                                    .ID_UNIDADE
                                                            }
                                                        />
                                                    ),
                                                    size: "lg",
                                                });
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faEnvelope}
                                                className="mr-2 icon-md"
                                            />{" "}
                                            Enviar Formulários
                                        </button> */}

                                        <button
                                            type="button"
                                            className="flex-grow-1 btn btn-sm  btn-light-primary btn-shadow font-weight-bold text-uppercase py-4 m-1"
                                            onClick={() => {
                                                setShow(true);
                                                setModal({
                                                    headerComponent:
                                                        "Cadastrar Jornada Etapa",
                                                    IconHeader: faAngleRight,
                                                    Component: () => (
                                                        <VincularJornadaEtapa
                                                            idEtapaJornada={
                                                                res.ID_ETAPA_JORNADA
                                                            }
                                                            updateList={
                                                                updateList
                                                            }
                                                            idUnidade={
                                                                res.UNIDADE
                                                                    .ID_UNIDADE
                                                            }
                                                            idConta={
                                                                props.idConta
                                                            }
                                                            setShow={setShow}
                                                        />
                                                    ),
                                                    size: "sm",
                                                });
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faLink}
                                                className="mr-2 icon-md"
                                            />{" "}
                                            Vincular Jornada Etapa
                                        </button>

                                        {ACESSOS.VENDAS.ID_MODULO !== id && (
                                            <button
                                                className="flex-grow-1 btn btn-sm  btn-light-info btn-shadow font-weight-bold text-uppercase py-4 m-1"
                                                onClick={() => {
                                                    const ID_MODULO =
                                                        modulo === "Geral"
                                                            ? 0
                                                            : tipoCaso[modulo]
                                                                  .idTipoCaso;
                                                    AbrirAtendimentoSelecionandoTipoCaso(
                                                        setShow,
                                                        setModal,
                                                        {
                                                            ID_MODULO,
                                                            editCliente: false,
                                                            defaultDesc:
                                                                props.DefaultDescAberturaDeCaso,
                                                            setShow: setShow,
                                                            cliente: {
                                                                ...props.cliente,
                                                                ID_CONTA:
                                                                    props
                                                                        .cliente
                                                                        ?.ID_CONTA ||
                                                                    0,
                                                                DS_CONTA:
                                                                    props
                                                                        .cliente
                                                                        ?.DS_NOME ||
                                                                    "",
                                                                PRODUTOS: [res],
                                                            },
                                                            idUnidade:
                                                                res.UNIDADE
                                                                    .ID_UNIDADE,
                                                        }
                                                    );
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faDoorOpen}
                                                    className="mr-2 icon-md"
                                                />{" "}
                                                Abrir Caso
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <ModalComponent
                setShow={setShow}
                show={show}
                ModalComponent={modal}
            />
        </>
    ) : (
        <div className="d-flex justify-content-center align-items-center font-weight-100">
            <span>Não existem vendas para esse cliente</span>
        </div>
    );
}
